import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "data-testid": "step-uploadSucceeded",
  class: "container container--slim step-thx-page step--upload-result--succeeded"
}
const _hoisted_2 = { class: "container__client-zone-header" }
const _hoisted_3 = { class: "image-wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "container__subheader t-center t-bold" }
const _hoisted_6 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t(`${_ctx.TRANSLATION_KEY}.header`)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        class: "w-80",
        src: require('@/assets/ok2.svg'),
        alt: "Success"
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.t(`${_ctx.TRANSLATION_KEY}.subheader`)), 1),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_SubmitButton, {
        "data-testid": "btn-uploadSucceeded-nextStep",
        action: _ctx.action.UPLOAD_SUMMARY,
        class: "button button--submit",
        "cy-data": "go-to-personal-data"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t(`${_ctx.TRANSLATION_KEY}.next`)), 1)
        ]),
        _: 1
      }, 8, ["action"])
    ])
  ]))
}